// @flow

type Window = {
  name: string,
  parent: ?Window,
  postMessage: (message: any, targetOrigin: string) => void,
};

function postWidgetMessage(window: ?Window, event: string, props?: any) {
  if (window == null || window.parent == null) return;

  window.parent.postMessage(JSON.stringify({ event, iframeName: window.name, ...props }), '*');
}

export function updateWidgetContentHeight(window: Window, contentHeight: number) {
  postWidgetMessage(window, 'updateContentHeight', { contentHeight });
}

export function updateWidgetScroll(window: Window, offsetTop: number) {
  postWidgetMessage(window, 'updateScroll', { offsetTop });
}



// WEBPACK FOOTER //
// ./src/shared/utils/widgetMessaging.js